import { Injectable } from '@angular/core';
import { BaseService } from '@plantefeve/common/api/base.service';
import { Observable, tap } from 'rxjs';
import { ListUser, Role, UpsertUser, User } from '../models/users.model';
import { SearchModel } from '@plantefeve/common/models/base-list.model';
import { ListSearchParameters } from '@plantefeve/common/models/filter.models';

@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseService {
  protected readonly _route = 'api/users';

  public searchUsers(userFilter: ListSearchParameters): Observable<SearchModel<ListUser>> {
    return this._httpClient.post<SearchModel<ListUser>>(`${this._route}/search`, userFilter);
  }

  public getUser(userId: string): Observable<User> {
    return this._httpClient.get<User>(`${this._route}/${userId}`);
  }

  public getUserRoles(userId: string): Observable<Role[]> {
    return this._httpClient.get<Role[]>(`${this._route}/${userId}/roles`);
  }

  public getRoles(): Observable<Role[]> {
    return this._httpClient.get<Role[]>(`${this._route}/roles`);
  }

  public create(user: UpsertUser): Observable<User> {
    return this._httpClient
      .post<User>(this._route, user)
      .pipe(tap(() => this._toastService.showSuccess('Gebruiker aangemaakt')));
  }

  public update(userId: string, user: UpsertUser): Observable<User> {
    return this._httpClient
      .put<User>(`${this._route}/${userId}`, user)
      .pipe(tap(() => this._toastService.showSuccess('Gegevens succesvol bijgewerkt')));
  }

  public updateUserRoles(userId: string, newUserRoles: string[]): Observable<Role[]> {
    return this._httpClient.put<Role[]>(`${this._route}/${userId}/roles`, newUserRoles);
  }

  public changePassword(userId: string, password: string): Observable<User> {
    return this._httpClient
      .patch<User>(`${this._route}/${userId}/password`, { password })
      .pipe(tap(() => this._toastService.showSuccess('Wachtwoord succesvol bijgewerkt')));
  }

  public blockUser(userId: string, block: boolean): Observable<boolean> {
    return this._httpClient
      .patch<boolean>(`${this._route}/${userId}/block`, block)
      .pipe(tap(() => this._toastService.showSuccess(`Gebruiker ${block ? 'geblokkeerd' : 'gedeblokkeerd'}`)));
  }
}
